var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMan5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 419 419",
    style: {
      enableBackground: "new 0 0 419 419"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD3AE"
    },
    cx: 128.928,
    cy: 146,
    r: 27.89
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD3AE"
    },
    cx: 290.063,
    cy: 146,
    r: 27.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M128.928,179.89c-18.687,0-33.89-15.203-33.89-33.89s15.203-33.89,33.89-33.89 s33.89,15.203,33.89,33.89S147.615,179.89,128.928,179.89z M128.928,124.11c-12.07,0-21.89,9.82-21.89,21.89 s9.82,21.89,21.89,21.89s21.89-9.82,21.89-21.89S140.998,124.11,128.928,124.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M290.063,179.89c-18.687,0-33.89-15.203-33.89-33.89s15.203-33.89,33.89-33.89 s33.89,15.203,33.89,33.89S308.75,179.89,290.063,179.89z M290.063,124.11c-12.07,0-21.89,9.82-21.89,21.89 s9.82,21.89,21.89,21.89s21.89-9.82,21.89-21.89S302.133,124.11,290.063,124.11z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A88D6"
    },
    d: "M258.855,241.97c0.19,0.05,0.39,0.09,0.58,0.14c10.46,2.53,20.19,6.93,28.83,12.81 c23.39,15.92,38.75,42.77,38.75,73.19V413h-47.04h-140.96h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 c8.64-5.88,18.37-10.28,28.83-12.81c0.19-0.05,0.39-0.09,0.58-0.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M297.995,94.5V146c-13.19,0-23.89-10.69-23.89-23.89V99.04c0-9.94-10.18-16.63-19.3-12.67 c-14.46,6.26-29.88,9.39-45.31,9.39s-30.85-3.13-45.3-9.39c-1.82-0.79-3.69-1.16-5.5-1.16c-7.28,0-13.81,5.88-13.81,13.83v23.07 c0,13.2-10.7,23.89-23.89,23.89V94.5c0-48.877,39.623-88.5,88.5-88.5l0,0C258.372,6,297.995,45.623,297.995,94.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M139.015,289v124h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 C136.025,265.12,139.015,276.71,139.015,289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M327.015,328.11V413h-47.04V289c0-12.29,2.99-23.88,8.29-34.08 C311.655,270.84,327.015,297.69,327.015,328.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M259.435,242.11V260c0,27.58-22.36,49.94-49.94,49.94s-49.94-22.36-49.94-49.94v-17.89 c0.19-0.05,0.39-0.09,0.58-0.14c14.1,9.49,31.08,15.03,49.36,15.03s35.26-5.54,49.36-15.03 C259.045,242.02,259.245,242.06,259.435,242.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M297.995,146v22.5c0,30.35-15.28,57.13-38.56,73.07c-0.19,0.14-0.39,0.27-0.58,0.4 c-14.1,9.49-31.08,15.03-49.36,15.03s-35.26-5.54-49.36-15.03c-0.19-0.13-0.39-0.26-0.58-0.4c-23.28-15.94-38.56-42.72-38.56-73.07 V146c13.19,0,23.89-10.69,23.89-23.89V99.04c0-7.95,6.53-13.83,13.81-13.83c1.81,0,3.68,0.37,5.5,1.16 c14.45,6.26,29.87,9.39,45.3,9.39s30.85-3.13,45.31-9.39c9.12-3.96,19.3,2.73,19.3,12.67v23.07 C274.105,135.31,284.805,146,297.995,146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M257.875,242.62c-6.74,12.83-16.55,23.81-28.44,31.95 c-0.19,0.14-0.39,0.27-0.58,0.4c-14.1,9.49-31.08,15.03-49.36,15.03c-6.5,0-12.84-0.7-18.94-2.04c-0.66-3.23-1-6.57-1-9.99v-35.86 c0.19-0.05,0.39-0.09,0.58-0.14c14.1,9.49,31.08,15.03,49.36,15.03C227.355,257,243.975,251.71,257.875,242.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M191.135,241.97c10.02,6.74,21.5,11.49,33.86,13.68 c-5.03,0.89-10.21,1.35-15.5,1.35c-18.28,0-35.26-5.54-49.36-15.03c-0.19-0.13-0.39-0.26-0.58-0.4 c-23.28-15.94-38.56-42.72-38.56-73.07V146c13.19,0,23.89-10.69,23.89-23.89V99.04c0-7.95,6.53-13.83,13.81-13.83 c1.81,0,3.68,0.37,5.5,1.16c4.58,1.98,9.26,3.65,14,5.01c-1.45,2.16-2.31,4.77-2.31,7.66v23.07c0,13.2-10.7,23.89-23.89,23.89v22.5 c0,30.35,15.28,57.13,38.56,73.07C190.745,241.71,190.945,241.84,191.135,241.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M209.495,263c-18.88,0-37.107-5.551-52.71-16.052l-0.167-0.113c-0.174-0.117-0.35-0.238-0.522-0.362 c-25.737-17.656-41.1-46.799-41.1-77.973v-74c0-52.107,42.393-94.5,94.5-94.5s94.5,42.393,94.5,94.5v74 c0,31.174-15.362,60.316-41.099,77.972c-0.173,0.125-0.35,0.245-0.524,0.363l-0.129,0.088c-0.012,0.008-0.024,0.017-0.037,0.025 C246.603,257.449,228.375,263,209.495,263z M209.495,12c-45.491,0-82.5,37.009-82.5,82.5v74c0,27.241,13.439,52.706,35.95,68.119 c0.057,0.039,0.113,0.079,0.168,0.12c0.068,0.05,0.14,0.096,0.21,0.144l0.199,0.135C177.101,246.156,193.011,251,209.495,251 s32.395-4.844,46.01-14.008l0.156-0.106c0.071-0.048,0.145-0.096,0.215-0.147c0.055-0.041,0.111-0.081,0.168-0.12 c22.511-15.413,35.95-40.878,35.95-68.119v-74C291.995,49.009,254.986,12,209.495,12z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M243.122,34.836c14.321,8.103,25.451,21.212,30.997,36.933"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M274.119,77.771c-2.473,0-4.789-1.541-5.658-4.006c-5.03-14.259-15.078-26.23-28.293-33.708 c-2.884-1.632-3.899-5.293-2.268-8.177c1.633-2.884,5.295-3.899,8.177-2.267c15.738,8.905,27.707,23.167,33.701,40.159 c1.103,3.125-0.537,6.552-3.662,7.654C275.455,77.66,274.781,77.771,274.119,77.771z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M209.495,26c4.631,0,9.156,0.462,13.531,1.342"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M223.033,33.343c-0.392,0-0.79-0.039-1.189-0.119C217.805,32.412,213.65,32,209.495,32 c-3.313,0-6-2.686-6-6s2.687-6,6-6c4.948,0,9.898,0.491,14.714,1.46c3.249,0.653,5.353,3.817,4.699,7.065 C228.335,31.375,225.832,33.343,223.033,33.343z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M209.495,315.94c-30.845,0-55.94-25.095-55.94-55.94v-18.43h12V260 c0,24.229,19.711,43.94,43.94,43.94s43.94-19.711,43.94-43.94v-18.43h12V260C265.435,290.845,240.34,315.94,209.495,315.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M297.995,152c-16.481,0-29.89-13.408-29.89-29.89V99.04c0-2.682-1.286-5.064-3.527-6.534 c-2.237-1.468-4.929-1.698-7.384-0.632c-15.155,6.561-31.202,9.886-47.7,9.886c-16.502,0-32.545-3.326-47.685-9.884 c-1.019-0.442-2.065-0.666-3.115-0.666c-3.756,0-7.81,2.994-7.81,7.83v23.07c0,16.481-13.409,29.89-29.89,29.89v-12 c9.865,0,17.89-8.025,17.89-17.89V99.04c0-10.934,8.887-19.83,19.81-19.83c2.703,0,5.356,0.557,7.889,1.656 c13.621,5.901,28.06,8.894,42.911,8.894c14.849,0,29.291-2.993,42.926-8.896c6.135-2.663,13.142-2.064,18.739,1.608 c5.601,3.674,8.945,9.868,8.945,16.568v23.07c0,9.865,8.025,17.89,17.89,17.89v12H297.995z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M177.885,166.437c-1.58,0-3.13-0.64-4.24-1.75c-1.12-1.12-1.76-2.67-1.76-4.25s0.64-3.12,1.76-4.24 c1.39-1.39,3.46-2.03,5.41-1.64c0.39,0.08,0.76,0.19,1.13,0.34c0.36,0.15,0.71,0.34,1.03,0.55c0.33,0.22,0.64,0.47,0.91,0.75 c0.28,0.28,0.53,0.58,0.75,0.91s0.4,0.68,0.55,1.04c0.15,0.36,0.27,0.74,0.34,1.12c0.08,0.39,0.12,0.78,0.12,1.17 s-0.04,0.79-0.12,1.18c-0.07,0.38-0.19,0.76-0.34,1.12s-0.33,0.71-0.55,1.03c-0.22,0.33-0.47,0.64-0.75,0.92 C181.015,165.797,179.465,166.437,177.885,166.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M245.885,166.437c-0.39,0-0.79-0.04-1.17-0.11c-0.38-0.08-0.76-0.2-1.12-0.35 c-0.37-0.15-0.71-0.33-1.04-0.55c-0.33-0.22-0.64-0.47-0.91-0.74c-0.28-0.28-0.53-0.59-0.75-0.92c-0.22-0.32-0.4-0.67-0.55-1.03 c-0.15-0.36-0.27-0.74-0.34-1.12c-0.08-0.39-0.12-0.79-0.12-1.18s0.04-0.78,0.12-1.17c0.07-0.38,0.19-0.76,0.34-1.12 s0.33-0.71,0.55-1.04c0.22-0.33,0.47-0.63,0.75-0.91c0.27-0.28,0.58-0.53,0.91-0.75c0.33-0.21,0.67-0.4,1.04-0.55 c0.36-0.15,0.74-0.26,1.12-0.34c1.95-0.39,4.02,0.25,5.41,1.64c0.28,0.28,0.53,0.58,0.75,0.91s0.4,0.68,0.55,1.04 c0.15,0.36,0.27,0.74,0.34,1.12c0.08,0.39,0.12,0.78,0.12,1.17s-0.04,0.79-0.12,1.18c-0.07,0.38-0.19,0.76-0.34,1.12 s-0.33,0.71-0.55,1.03c-0.22,0.33-0.47,0.64-0.75,0.92C249.015,165.797,247.465,166.437,245.885,166.437z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M202.552,180c-3.313,0-6-2.686-6-6v-16.857c0-3.204-2.606-5.81-5.81-5.81h-28.58 c-3.313,0-6-2.686-6-6s2.687-6,6-6h28.58c9.82,0,17.81,7.99,17.81,17.81V174C208.552,177.314,205.865,180,202.552,180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M256.829,151.333h-24c-3.313,0-6-2.686-6-6s2.687-6,6-6h24c3.313,0,6,2.686,6,6 S260.142,151.333,256.829,151.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M221.495,215.333h-24c-3.313,0-6-2.686-6-6s2.687-6,6-6h24c3.313,0,6,2.686,6,6 S224.809,215.333,221.495,215.333z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A88D6"
    },
    d: "M327.015,328.11V348h-45.7h-1.34v-59c0-12.29,2.99-23.88,8.29-34.08 C311.655,270.84,327.015,297.69,327.015,328.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A88D6"
    },
    d: "M139.015,289v59h-47.03v-19.89c0-30.42,15.35-57.27,38.74-73.19 C136.025,265.12,139.015,276.71,139.015,289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M285.975,413h-12V289c0-12.816,3.1-25.558,8.966-36.846l10.648,5.533 c-5.052,9.724-7.614,20.259-7.614,31.313V413z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.315,
    y: 342,
    style: {
      fill: "#333333"
    },
    width: 47.03,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M307.015,399c-3.313,0-6-2.686-6-6v-27c0-3.314,2.687-6,6-6s6,2.686,6,6v27 C313.015,396.314,310.329,399,307.015,399z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M135.665,266.92c-15.21,15.89-24.56,37.45-24.56,61.19V348 h-19.12v-19.89c0-30.42,15.35-57.27,38.74-73.19C132.705,258.74,134.365,262.75,135.665,266.92z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.052,
    y: 348,
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    width: 16.63,
    height: 65
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M327.015,419H91.985c-3.314,0-6-2.686-6-6v-84.89c0-31.306,15.463-60.521,41.364-78.15 c9.415-6.408,19.76-11.007,30.749-13.671c0.131-0.033,0.264-0.065,0.397-0.096l0.119-0.028l3.05,11.606 c-0.154,0.041-0.311,0.078-0.469,0.114l-0.119,0.028c-0.018,0.004-0.093,0.024-0.11,0.028c-9.597,2.321-18.636,6.338-26.865,11.938 c-22.614,15.392-36.116,40.899-36.116,68.23V407h223.03v-78.89c0-27.327-13.505-52.833-36.126-68.23 c-8.229-5.6-17.268-9.617-26.865-11.938c-0.04-0.01-0.079-0.02-0.118-0.03l-0.112-0.026c-0.157-0.036-0.314-0.073-0.467-0.114 l3.05-11.606l0.12,0.028c0.133,0.031,0.266,0.062,0.396,0.095c10.989,2.664,21.333,7.263,30.749,13.67 c25.907,17.633,41.374,46.848,41.374,78.15V413C333.015,416.314,330.329,419,327.015,419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M145.015,413h-12V289c0-11.055-2.562-21.59-7.614-31.313l10.648-5.533 c5.865,11.288,8.966,24.029,8.966,36.846V413z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.985,
    y: 342,
    style: {
      fill: "#333333"
    },
    width: 47.03,
    height: 12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M257.885,123c-3.313,0-6-2.686-6-6v-12.231c0-3.314,2.687-6,6-6c3.313,0,6,2.686,6,6V117 C263.885,120.314,261.199,123,257.885,123z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M341,419H78.23c-3.313,0-6-2.686-6-6s2.687-6,6-6H341c3.313,0,6,2.686,6,6S344.313,419,341,419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M373,419h-11c-3.313,0-6-2.686-6-6s2.687-6,6-6h11c3.313,0,6,2.686,6,6S376.313,419,373,419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M57,419H46c-3.313,0-6-2.686-6-6s2.687-6,6-6h11c3.313,0,6,2.686,6,6S60.313,419,57,419z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan5);
export default __webpack_public_path__ + "static/media/man5.f65fd8ec5b5e215caa8b7151db04e3e0.svg";
export { ForwardRef as ReactComponent };